import { z } from "zod";

export const userSignUpSchema = z.object({
  password: z
    .string({ required_error: "Le mot de passe est obligatoire" })
    .min(3, {
      message: "Login doit comporter au moins 3 caractères.",
    }),

  firstName: z.string({ required_error: "Le prénom est obligatoire" }).min(3, {
    message: "Le nom d'utilisateur doit comporter au moins 3 caractères.",
  }),

  lastName: z.string({ required_error: "Le nom est obligatoire" }).min(3, {
    message: "Le prénom d'utilisateur doit comporter au moins 3 caractères.",
  }),
  email: z
    .string({ required_error: "L'adresse e-mail est obligatoire" })
    .email({ message: "Adresse E-mail invalide" }),

  role: z
    .string({ required_error: "Le rôle est obligatoire" })
    .min(1, { message: "Sélectionner un rôle" }),
});

export type UserSignUpFormValues = z.infer<typeof userSignUpSchema>;

export const userUpdateSchema = z
  .object({
    password: z.string().min(3, {
      message: "Login doit comporter au moins 3 caractères.",
    }),

    firstName: z.string().min(3, {
      message: "Le nom d'utilisateur doit comporter au moins 3 caractères.",
    }),

    lastName: z.string().min(3, {
      message: "Le prénom d'utilisateur doit comporter au moins 3 caractères.",
    }),
    email: z.string().email({ message: "Adresse E-mail invalide" }),

    role: z.string().min(1, { message: "Sélectionner un rôle" }),
  })
  .partial();

export type UserUpdateFormValues = z.infer<typeof userUpdateSchema>;

export const passwordSchema = z
  .object({
    oldPassword: z.string().min(6, {
      message: "Le mot de passe doit contenir au moins 8 caractères.",
    }),
    newPassword: z.string().min(6, {
      message: "Le mot de passe doit contenir au moins 8 caractères.",
    }),
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Les mots de passe ne correspondent pas.",
    path: ["confirmPassword"],
  });

export type UserPasswordFormValues = z.infer<typeof passwordSchema>;

export const UserLoginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(6, {
    message: "Le mot de passe doit contenir au moins 8 caractères.",
  }),
});

export type UserLoginFormValues = z.infer<typeof UserLoginSchema>;

export const newPasswordSchema = z
  .object({
    newPassword: z.string().min(6, {
      message: "Le mot de passe doit contenir au moins 8 caractères.",
    }),
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Les mots de passe ne correspondent pas.",
    path: ["confirmPassword"],
  });

export type UserNewPasswordFormValues = z.infer<typeof newPasswordSchema>;

export const resetPasswordSchema = z.object({
  email: z.string({ required_error: "Adresse email est obligatoire" }).email(),
});

export type UserResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;
